import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './theme/shared/shared.module';
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { AuthInterceptor } from './interceptors/auth-interceptor';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoaderService } from './loader/loader.service';
import { LoaderInterceptor } from './loader/loader.interceptor';
import { LoaderComponent } from './loader/loader.component';
import { CustomSharedModule } from './custom/shared/custom.shared.module';
import { SplashScreenComponent } from './splashScreen/splash-screen/splash-screen.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ResponseModifierInterceptor } from './interceptors/response-modifier-interceptor';
import { AdminComponent } from './theme/layout/admin/admin.component';
//import { ChangePasswordComponent } from './pages/login/change-password/change-password.component';
import { ResetPasswordComponent } from './pages/login/reset-password/reset-password.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AdminComponent,
    NavigationComponent,
    NavContentComponent,
    NavGroupComponent,
    NavCollapseComponent,
    NavItemComponent,
    NavBarComponent,
    NavLeftComponent,
    NavRightComponent,
    ConfigurationComponent,
    LoaderComponent,
    SplashScreenComponent,
    //ChangePasswordComponent,
    ResetPasswordComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ToastrModule.forRoot(),
    ServiceWorkerModule.register('service-worker.js', {
      enabled: environment.production,
    }),
    AppRoutingModule,
    NgbModule,
    SharedModule,
    CustomSharedModule,
    PdfViewerModule
  ],
  providers: [NavigationItem,
    LoaderService,
    { provide: HTTP_INTERCEPTORS, useClass: ResponseModifierInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
